import { MARKETING_WEBSITE_DOMAINS } from 'constants/countriesDetails';

// To be extended in the future with localization
export const parseFooterDataUrls = ({
  url,
  locale,
}: {
  url: string;
  locale: string;
}): string => {
  if (url?.startsWith('/')) {
    return `${
      (MARKETING_WEBSITE_DOMAINS[locale]
        ? MARKETING_WEBSITE_DOMAINS[locale]
        : MARKETING_WEBSITE_DOMAINS['en-GB']) as string
    }${url}`;
  }
  return url;
};

export function chunk<T>(array: T[], numberOfChunks: number): T[][] {
  if (!array || numberOfChunks <= 0) {
    return [];
  }

  const chunks: T[][] = [];
  const chunkSize = Math.ceil(array.length / numberOfChunks);

  for (let index = 0; index < array.length; index += chunkSize) {
    chunks.push(array.slice(index, index + chunkSize));
  }

  return chunks;
}
